var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'project-status overflow-ellipsis',
    _vm.color,
    _vm.clickable ? 'project-status--clickable' : '',
    _vm.multiline ? 'project-status--multiline' : '',
  ],attrs:{"title":_vm.statusText},on:{"click":_vm.clickElement}},[_vm._v(" "+_vm._s(_vm.statusText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }